module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-content', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-container', {
    staticClass: "text-xs-center"
  }, [(_vm.message) ? _c('v-alert', {
    staticClass: "success",
    attrs: {
      "value": true
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.message) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": "error",
      "type": "warning",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.error) + " ")])]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "green darken-1"
    }
  }, [_c('v-toolbar-title', [_vm._v("One Time Pin")])], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v(" One Time Pin has been sent to your email, enter the Pin to proceed ")]), _vm._v(" "), _c('v-form', [_c('v-text-field', {
    attrs: {
      "name": "One Time Pin",
      "label": "OTP",
      "type": "text"
    },
    model: {
      value: (_vm.otp.token),
      callback: function($$v) {
        _vm.$set(_vm.otp, "token", $$v)
      },
      expression: "otp.token"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "green lighten-2"
    },
    on: {
      "click": _vm.resendOTP
    }
  }, [_vm._v("Resend Token")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validateOTP($event)
      },
      "click": _vm.validateOTP
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-800111c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tokenvalidate.vue
// module id = 1067
// module chunks = 2